export default __webpack_public_path__ + "9b91acaef5f55a1e04198139265a117e.svg";